<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in ratings" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-rating-edit', params: { ratingId: row.id }}">{{ row.name }}</d-link>
        </td>
      </tr>
      <tr v-if="ratings.length === 0">
        <td colspan="6" class="no-content">Ainda não foi criada nenhuma avaliação.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'rating-table',
  components: {
  },
  props: {
    ratings: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}
</style>
